import { UserActivityStats } from "../../../models/DashboardStats";

export type ActivityMetricKey =
  | "booked"
  | "collected"
  | "depollutedCount"
  | "crushedCount"
  | "dismantlingListsCreated"
  | "createdCount"
  | "removedCount"
  | "imagedCount"
  | "locatedCount"
  | "pricedCount"
  | "listedCount"
  | "pickedCount"
  | "shippedCount"
  | "scrappedCount"
  | "deletedCount"
  | "damagedCount";

export interface ActivityMetric {
  key: ActivityMetricKey;
  label: string;
}

/** Selectable activity columns, in table display order (excludes Total / derived columns). */
export const ACTIVITY_METRICS: ActivityMetric[] = [
  { key: "booked", label: "Vehicles Booked" },
  { key: "collected", label: "Vehicles Collected" },
  { key: "depollutedCount", label: "Vehicles Depolluted" },
  { key: "crushedCount", label: "Vehicles Crushed" },
  { key: "dismantlingListsCreated", label: "Jobs Created" },
  { key: "createdCount", label: "Parts Created" },
  { key: "removedCount", label: "Removed" },
  { key: "imagedCount", label: "Imaged" },
  { key: "locatedCount", label: "Located" },
  { key: "pricedCount", label: "Priced" },
  { key: "listedCount", label: "Listed" },
  { key: "pickedCount", label: "Picked" },
  { key: "shippedCount", label: "Shipped" },
  { key: "scrappedCount", label: "Scrapped" },
  { key: "deletedCount", label: "Deleted" },
  { key: "damagedCount", label: "Damage Reports" },
];

export const DEFAULT_ACTIVITY_METRIC: ActivityMetricKey = ACTIVITY_METRICS[0].key;

export function getMetricValue(row: UserActivityStats | undefined, key: ActivityMetricKey): number {
  return row?.[key] ?? 0;
}
